import { createApiCall } from 'lib/base';

const CREATE_BUY_ORDER_API_ID = 'DASHBOARD/CREATE_BUY_ORDER_API_ID';

const apiCall = createApiCall(CREATE_BUY_ORDER_API_ID, payload => ({
  endpoint: `/api/admin/user-program-orders/create-buy`,
  method: 'POST',
  body: payload,
  notify: true,
}));

export default apiCall;
